<template>
  <v-card
    v-if="summary"
    class="ma-2"
    :to="{ name: feature.services.routerName }"
  >
    <v-card-text class="indigo lighten-5">
      <div class="d-flex">
        <div class="mt-4 mr-4">
          <v-icon large color="purple">{{ icon.scheduledService }}</v-icon>
          <div class="ml-1 caption">Services</div>
        </div>
        <v-container>
          <v-row>
            <v-col>
              <div class="d-flex">
                <div>
                  <v-icon color="red">{{ icon.serviceStatusOpen }}</v-icon>
                  <div class="caption">Open</div>
                </div>
                <div
                  class="ml-2 display-1 text--secondary"
                  v-text="qtyOpenServices"
                />
              </div>
            </v-col>
            <v-col>
              <div class="d-flex">
                <div>
                  <v-icon color="green">{{ icon.serviceStatusClosed }}</v-icon>
                  <div class="caption">closed</div>
                </div>
                <div
                  class="ml-2 display-1 text--secondary"
                  v-text="qtyClosedServices"
                />
              </div>
            </v-col>
            <v-col>
              &nbsp;
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, computed } from 'vue'
import { userData } from '@/store/UserSession'
import { todayISOString } from '@/use/DateFormatter'
import { feature, icon } from '@/use/Constants'
import { host } from '@/services/HostAPI'
export default {
  name: 'ServiceDashboardWidget',
  setup() {
    const summary = ref([])

    const loadData = async () => {
      const rq = {
        Criteria: {
          RequestList: [
            {
              UserId: userData.value.UserId,
              ServiceDate: todayISOString()
            }
          ]
        }
      }
      const rs = await host.scheduledService.cardList(rq)
      summary.value = rs.InfoList[0].ServiceItemList
    }

    const qtyOpenServices = computed(
      () => summary.value.filter(item => item.Status == 'O').length
    )

    const qtyClosedServices = computed(
      () => summary.value.filter(item => item.Status !== 'O').length
    )

    loadData()

    return { summary, feature, icon, qtyOpenServices, qtyClosedServices }
  }
}
</script>
